import axios from "axios";

const locationsService = {
    getLoactions,
    addLocation,
    deleteLocation
}

async function getLoactions() {
    return await axios.get(`/Locations/GetLocations`);
}

async function addLocation(data) {
    return await axios.post(`/Locations/AddLocation`, data);
}

async function deleteLocation(data) {
    return await axios.delete(`/Locations/DeleteLoaction/${data}`);
}

export default locationsService;